var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dynamic-data"},[_vm._m(0),_c('div',{staticStyle:{"height":"40px"}}),_c('div',{ref:"dynamicData",staticClass:"dynamicData"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"little-box"},[_c('div',{staticClass:"little-box_title"},[_vm._v("增值数据")]),_c('div',[_vm._v("更多")])])
}]

export { render, staticRenderFns }